"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleList = void 0;
exports.ModuleList = [
    'wix-ecom-backend',
    'wix-echo-backend',
    'wix-blog-backend',
    'wix-loyalty-backend',
    'wix-portfolio-backend',
    'wix-pro-gallery-backend',
    'wix-bookings.v2',
    'wix-inbox.v2',
    'wix-email-marketing.v2',
    'wix-forum.v2',
    'wix-loyalty.v2',
    'wix-activity-counters.v2',
    'wix-business-tools.v2',
    'wix-stores.v2',
    'wix-marketing-tags.v2',
    'wix-sender-details.v2',
    'wix-media.v2',
    'wix-pricing-plans.v2',
    'wix-members.v2',
    'wix-groups.v2',
    'wix-marketing.v2',
    'wix-data-backup-service-v2',
    'wix-restaurants-backend',
    'wix-currencies.v2',
    'wix-authentication-management.v2',
    'wix-auth-management.v2',
    'wix-redirects.v1',
    'wix-ecom.v2',
    'wix-data.v2',
    'wix-crm.v2',
    'wix-notifications.v2',
    'wix-workflows.v2',
    'wix-captcha.v2',
    'wix-table-reservations.v2',
    'wix-categories.v2',
    'wix-reviews.v2',
    'wix-notifications.v3',
    'wix-comments.v2',
    'wix-rise.v2',
    'wix-bookings.v1',
    'wix-search.v2',
    'wix-members-about.v1',
    'wix-forms.v2',
    'wix-restaurants.v2',
    'wix-ads-txt.v1',
    'wix-members.v3',
    'wix-custom-fields-schema.v2',
    'wix-export-async-job.v1',
    'wix-settings.v2',
    'wix-multilingual.v2',
    'wix-app-settings.v2',
    'wix-calendar.v3',
    'wix-billing.v2',
    'wix-stores.v3',
    'wix-payments.v2',
    'wix-ep-plugins.v1',
    'wix-events.v2',
    'wix-urls.v2',
    'wix-app-plugins-site-plugins.v1',
    'wix-search.v3',
    'wix-app-management.v2',
    'wix-site-plugins.v1',
    'wix-dashboard-management.v2',
    'wix-editor-deployments.v1',
    'wix-tags.v1',
    'wix-packages.v1',
    'wix-domains.v1',
    'wix-moderation-rules.v1',
    'wix-automations.v2',
    'wix-referral.v1',
    'wix-custom-fields.v1',
    'wix-members.v1',
    'wix-subscription.v1',
    'wix-review-request.v1',
    'wix-site-actions.v2',
    'wix-members-area.v1',
    'wix-analytics-session.v1',
    'wix-analytics-data.v2',
    'wix-apps-installer.v1',
    'wix-async-jobs.v2',
    'migration-triggers.v1',
    'trigger-catalog.v1',
    'wix-automations.v1',
    'wix-assistant-widget.v1',
    'wix-editor-site-embeds.v1',
    'wix-automations-actioncatalog.v1',
    'wix-automations-activation-log.v1',
    'wix-assistant-playground.v1',
    'wix-instagram-media.v1',
    'wix-automations-activation-action-log.v1',
    'wix-analytics-session.v2',
    'wix-automations-activation-summary.v1',
    'wix-functions.v1',
    'wix-automations-runner.v1'
];
//# sourceMappingURL=module-list.js.map